import { h } from "preact";

function RightIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || 24}
      height={props.size || 24}
      viewBox="0 0 24 24"
      fill="none"
      stroke={props.color || 'currentColor'}
      stroke-width={props.strokeWidth || 1}
      stroke-linecap="round"
      stroke-linejoin="round"
      className={props.className || 'feather'}
    >
      <polyline points="9 18 15 12 9 6" />
    </svg>
  );
}

export default RightIcon